<template>
    <BasePanel
        headline="lang_LABEL_RELEASES_PANEL_CAPTION_DIGITAL_DISTRIBUTION"
        :alvqa="alvqa"
    >
    <!--  show-select
    v-model="selected"
     -->
        <template v-slot:panelContent>
            <v-data-table
                :headers="headers"
                :items="listItems"
                
                hide-default-footer
                :header-props="{ sortIcon: '' }"
                :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
                :items-per-page="100"
                class="noMinWidth"
            >
            <!-- HEADERS -->
                <template v-slot:[`header.data-table-select`]="{ on, props }"> 
                    <v-simple-checkbox
                        color="generalCheckbox"
                        v-bind="props"
                        v-on="on"
                        :alvqa="alvqa + '-list-checkbox-all-select'"
                        indeterminate-icon="check_box_outline_blank"
                    />
                </template>

                <template v-for="(header, i) in headers" v-slot:[`header.${header.value}`]>
                    <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
                </template>

            <!-- ROWS -->
                <!-- <template v-slot:[`item.data-table-select`]="{ isSelected, select, item }">
                    <v-simple-checkbox
                        color="generalCheckbox"
                        @input="select(!isSelected)"
                        :value="item.status === 'delivered' ? true : isSelected"
                        :alvqa="alvqa + '-list-checkbox-single-select'"
                        :disabled="item.status === 'delivered' ? true : false"
                        
                    />
                </template> -->
                <template v-slot:[`item.logo`]="{ item }">
                    <v-img 
                        :src="require('@/assets/logo/digital_distribution/' + item.platformId.toLowerCase() + '-22px.png')" 
                        contain height="22px" 
                        position="left"
                        :alvqa="alvqa + '-list-row-' + item.alvId + '-logo'"
                    />
                </template>
                <template v-slot:[`item.platformCompany`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-' + item.alvId + '-platform-company'">
                        {{ getPlatformCompany(item.platformId) }}
                    </div>
                </template>
                <template v-slot:[`item.status`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-' + item.alvId + '-status'">
                        {{ getStatus(item.status) }}
                    </div>
                </template>
                <!-- <template v-slot:[`item.digitalPreRelease`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-' + item.alvId + '-digital-prerelease'">
                        {{ getFormattedDate(item.digitalPreRelease) }}
                    </div>
                </template> -->
                <template v-slot:[`item.digitalRelease`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-' + item.alvId + '-digital-release'">
                        {{ getFormattedDate(item.digitalRelease) }}
                    </div>
                </template>
                <template v-slot:[`item.inlineEdit`]="{ item }">
                    <BaseIcon  
                        v-if="item.status !== 'delivered' && $store.getters.getDigitalDistributionIsBooked === 'yes'"
                        :alvqa="alvqa + '-list-row-' + item.id + '-icon-inline-edit'"
                        icon="edit" 
                        tooltipText="lang_GENERAL_CAPTION_ICON_EDIT"   
                        @click.stop="editInlineFunction(item)"
                    />
                    <BaseIcon  
                        v-if="$store.getters.getDigitalDistributionIsBooked === 'no'"
                        :alvqa="alvqa + '-list-row-' + item.id + '-icon-info'"
                        icon="info" 
                        color="grey"
                        tooltipText="lang_LABEL_RELEASES_DIGITAL_DISTRIBUTION_TOOLTIP_SWITCHNOW"   
                    />
                </template>
            </v-data-table>
        </template>
    </BasePanel>
</template>

<script>
import BasePanel from "@/components/_base/BasePanel"
import BaseIcon from '@/components/_buttons/BaseIcon'

export default {
    name: "ReleaseDigitalDistributionPanel",
    components: {
        BasePanel,
        BaseIcon
    },
    data() {
        return {
            context: 'ReleaseDigitalDistribution',
            alvqa: 'label-releases-edit-form-panel-digital-distribution'
        }
    },
    computed: {
        headers() {
            return [
                {
                    text: this.$t('lang_LABEL_RELEASES_CAPTION_PLATFORM'), 
                    align: 'left',
                    value: "logo",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-platform-logo'
                },
                {
                    text: this.$t('lang_GENERAL_CAPTION_COMPANY'), 
                    align: "left", 
                    value: "platformCompany",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-platform-company'
                },
                {
                    text: this.$t('lang_LABEL_RELEASES_CAPTION_STATUS'), 
                    align: "left", 
                    value: "status",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-status'
                },
                // {
                //     text: this.$t('lang_LABEL_RELEASES_CAPTION_DATE_PRERELEASE'), 
                //     align: "left", 
                //     value: "digitalPreRelease",
                //     class: 'text-no-wrap',
                //     alvqa: this.alvqa + '-header-prerelease-date'
                // },
                {
                    text: this.$t('lang_LABEL_RELEASES_CAPTION_DATE_DIGITAL'), 
                    align: "left", 
                    value: "digitalRelease",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-digital-release-date'
                },
                {
                    text: '', 
                    value: 'inlineEdit',
                    align: 'right',
                    sortable: false,
                    width: "70px",
                    class: 'text-no-wrap'
                }
            ]
        },
    
        listItems() {
             let distributionArray = this.$store.getters.getLabelReleasesDetails.digitalDistributionStatus 
             
             if(distributionArray === undefined){
                 return []
             }else{
                 let index = distributionArray.findIndex(element => {
                        return element.platformId === "qobuz" 
                    })
                if(index !== undefined){
                    distributionArray.splice(index,1)
                }
                return distributionArray
             }
        },
        
        selected: {
            get() { return this.$store.getters.getSelectedReleaseDigitalDistributionStatus },
            set(selected) { this.$store.commit('setSelectedReleaseDigitalDistributionStatus', selected) }
        }
    },
    methods: {
        getPlatformCompany(platformId) { 
            let platforms = this.$store.getters.getDigitalPlatforms

            if(platforms !== undefined) {
                return platforms.find(platform => {
                    return platform.platformId === platformId
                }).platformCompany
            }
        },
        getFormattedDate(date) {  
            if(date === null || date === undefined) return ''
            else return this.$d(new Date(date), 'alvDateFormat') 
        },
        getStatus(status) {
            if(status === null) return ''
            if(status === 'delivered') return this.$t('lang_LABEL_RELEASES_DIGITAL_DISTRIBUTION_STATUS_DELIVERED')
            if(status === 'pending') return this.$t('lang_LABEL_RELEASES_DIGITAL_DISTRIBUTION_STATUS_PENDING')
        },

        editInlineFunction(item) {
            this.$store.commit('setSelectedReleaseDigitalDistribution', item.id)
            let itemDeepCopy = JSON.parse(JSON.stringify(item))

            // prepare checkbox value
            // itemDeepCopy['selected'] === 'yes' ? itemDeepCopy['selected'] = true : itemDeepCopy['selected'] = false

            // set the copy in dialog details to edit
            this.$store.commit('setReleaseDigitalDistributionEditingDialogDetails', itemDeepCopy)
            this.$store.commit('setEditingDialogHeadline', this.$t("lang_GENERAL_CAPTION_EDITING_ENTRY")) // set headline
            this.$store.commit('setShowReleaseDigitalDistributionEditingDialog', true) 
        }
    }
}
</script>

<style>
    .noMinWidth table {
        min-width: 0px !important;
    }
</style>